<template>
    <img v-show="isShowToTop" src="@/assets/images/homePage/to-top-red.png" alt="" @click="toTop" />
</template>

<script>
export default {
    name: 'ToTop',
    data() {
        return {
            isShowToTop: false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.throttleScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.throttleScroll)
    },
    methods: {
        toTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        // 滚动节流
        // eslint-disable-next-line no-undef
        throttleScroll: _.throttle(function () {
            this.handleScroll()
        }, 200),
        handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if (scrollTop === 0) {
                return (this.isShowToTop = false)
            }
            if (!this.isShowToTop) {
                this.isShowToTop = true
            }
        }
    }
}
</script>

<style scoped lang="scss">
img {
    position: sticky;
    bottom: 8px;
    display: block;
    margin: 8px;
    margin-left: auto;
    height: 60px;
    width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/to-top/index.vue